/**
 * @generated SignedSource<<8abc15c58822b15b1955ebfbe19fe938>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DeMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
import { FragmentRefs } from "relay-runtime";
export type deMedicationFragment$data = {
  readonly __typename: "de_Medication";
  readonly composition: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly endDate: any | null;
  readonly eveningDosage: number;
  readonly id: string;
  readonly internalNotes: string | null;
  readonly isPermanentPrescription: boolean;
  readonly isPrescriptionRequired: boolean;
  readonly morningDosage: number;
  readonly name: string;
  readonly nightDosage: number;
  readonly noonDosage: number;
  readonly numberOfPackages: number;
  readonly patientId: string;
  readonly pharmaceuticalCentralNumber: string | null;
  readonly refuseSubstitutes: boolean;
  readonly startDate: any | null;
  readonly type: DeMedicationType;
  readonly unit: MedicationUnit;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly usageInstructions: string | null;
  readonly " $fragmentType": "deMedicationFragment";
};
export type deMedicationFragment$key = {
  readonly " $data"?: deMedicationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deMedicationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deMedicationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "refuseSubstitutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfPackages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eveningDosage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalNotes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrescriptionRequired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "morningDosage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nightDosage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noonDosage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pharmaceuticalCentralNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usageInstructions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "composition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPermanentPrescription",
      "storageKey": null
    }
  ],
  "type": "de_Medication",
  "abstractKey": null
};

(node as any).hash = "e9ccecfc561a2f17019b8d001f194667";

export default node;
